export default __webpack_public_path__ + "static/media/calender-outline.61af1f44.svg";